﻿export const hasCompleteAddress = (state) => {
    const address = state.addresslookup.selectedAddress;

    return address && Object.keys(address).length;
};

export const selectedProduct = (state) => {
    const code = state.products.selectedProduct;
    const products = state.products.available;

    for (let i = products.length - 1; i >= 0; i--) {
        const product = products[i];
        if (product.code === code) {
            return product;
        }
    }

    return null;
};

export const selectedVariant = (state) => {
    const code = state.products.selectedVariant;
    const product = selectedProduct(state);
    if (!product) {
        return null;
    }

    const variants = product.variants;
    if (!variants) {
        return null;
    }

    for (let i = variants.length - 1; i >= 0; i--) {
        const variant = variants[i];
        if (variant.code === code) {
            return variant;
        }
    }

    return null;
};

export const minimumPriceForBindingPeriod = (state) => {
    const code = state.products.selectedVariant;
    const product = selectedProduct(state);
    if (!product) {
        return null;
    }

    const variants = product.variants;
    if (!variants) {
        return null;
    }

    for (let i = variants.length - 1; i >= 0; i--) {
        const variant = variants[i];
        if (variant.code === code) {
            return variant.minimumPriceForBindingPeriod;
        }
    }

    return null;
};

export const otherProducts = (state) => {
    const code = state.products.selectedProduct;
    const products = state.products.available;
    if (!products) {
        return null;
    }

    let result = [];

    for(let i = products.length - 1 ; i >= 0; i--) {
        const product = products[i];
        if (product.code !== code) {
            result.push(product);
        }
    }

    return result;
}

export const otherVariants = (state) => {
    const code = state.products.selectedVariant;
    const product = selectedProduct(state);
    if (!product) {
        return null;
    }

    const variants = product.variants;
    if (!variants) {
        return null;
    }

    let result = [];

    for (let i = variants.length - 1; i >= 0; i--) {
        const variant = variants[i];
        if (variant.code !== code) {
            result.push(variant);
        }
    }

    return result;
};



export const selectedVas = (state) => {
    return state.vas.selectedVas;
};